(function ($) {
	// Cached selectors
	const $body = $('body');
	const $header = $('header');
	const $menuToggle = $('.main-menu-toggle');
	const $menus = $('header .menus');
	const $menuLinks = $('li.has-mega-menu > a');

	// Handle main menu toggle
	$menuToggle.on('click', function () {
		mainNav();
	});

	function mainNav() {
		$menuToggle.toggleClass("cross");
		$body.toggleClass("no-scroll");
		$header.toggleClass("menu-open");
		const $menuParent = $("#site-navigation").parent().toggleClass("open");

		if ($menuParent.hasClass("open")) {
			trapFocus($menus);
			disableScroll();
		} else {
			enableScroll();
		}
	}

	// Mega menu click toggle
	$menuLinks.on('click', function (e) {
		e.preventDefault();

		const $trigger = $(this);
		const $parent = $trigger.parent('li');
		const $megaMenu = $parent.find('.mega-menu').first();
		const isOpen = $parent.hasClass('has-mega-menu-open');

		const menuLabel = $trigger.text().trim().replace(/\s+/g, ' ');
		const isMobile = window.matchMedia("(max-width: 1024px)").matches;
		const clickAction = isMobile ? 'Main Menu Mobile drop down' : 'Main Menu Desktop drop down';

		// Push to dataLayer
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'click',
			'click_action': clickAction,
			'click_value': menuLabel
		});

		// Close all
		closeMegaMenus();

		if (!isOpen) {
			$parent.addClass('has-mega-menu-open');
			$megaMenu.addClass('is-visible');
			$('#menu-main, #menu-main-fr').addClass('mega-menu-open');
			$trigger.attr('aria-expanded', 'true');

			// Move focus to first link
			const $firstLink = $megaMenu.find('a').first();
			if ($firstLink.length) {
				$firstLink.focus();
			}

			updateMenuStatus('Menu opened');
		}
	});

	// Track clicks inside Mega Menu links
	$('body').on('click', '.mega-menu a', function () {
		const $link = $(this);
		const linkLabel = $link.text().trim();
		const isMobile = window.matchMedia("(max-width: 1024px)").matches;
		const clickAction = isMobile ? 'Main Menu Mobile click' : 'Mega Menu inner click';

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'click',
			'click_action': clickAction,
			'click_value': linkLabel
		});
	});

	// Accessibility: Update menu status
	function updateMenuStatus(message) {
		$('#menu-status').text(message);
	}
	// Close mega menu utility
	function closeMegaMenus() {
		$('li.has-mega-menu').removeClass('has-mega-menu-open').find('> a').attr('aria-expanded', 'false');
		$('.mega-menu').removeClass('is-visible');
		$('#menu-main, #menu-main-fr').removeClass('mega-menu-open');

		updateMenuStatus('Menu closed');
		$menuToggle.focus();
	}

	// Close mega menus on scroll
	$(window).on('scroll', closeMegaMenus);

	// Close mega menus on document click outside
	$(document).on('click', function (e) {
		if (!$(e.target).closest('li.has-mega-menu').length) {
			closeMegaMenus();
		}
	});

	// Trap focus within menu
	function trapFocus(element) {
		const focusableElements = element.find('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
		const firstFocusable = focusableElements.first();
		const lastFocusable = focusableElements.last();

		element.on('keydown', function (e) {
			if (e.key === 'Tab') {
				if (e.shiftKey && $(document.activeElement).is(firstFocusable)) {
					e.preventDefault();
					lastFocusable.focus();
				} else if (!e.shiftKey && $(document.activeElement).is(lastFocusable)) {
					e.preventDefault();
					firstFocusable.focus();
				}
			}
		});
	}

	// Keyboard accessibility for mega menu links
	$('body').on('keydown', '.has-mega-menu > a', function (e) {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			$(this).trigger('click');
		}
	});

	// Arrow key navigation inside mega menu
	$(document).on('keydown', function (e) {
		const $focused = $(document.activeElement);
		if ($focused.closest('.mega-menu').length) {
			const $links = $focused.closest('.mega-menu').find('a');
			const index = $links.index($focused);

			if (e.key === 'ArrowDown') {
				e.preventDefault();
				const next = $links.eq(index + 1);
				if (next.length) next.focus();
			}

			if (e.key === 'ArrowUp') {
				e.preventDefault();
				const prev = $links.eq(index - 1);
				if (prev.length) prev.focus();
			}

			if (e.key === 'Escape') {
				closeMegaMenus();
				$menuToggle.focus(); // optional: return focus to toggle
			}
		}
	});


	// Footer menu event tracking
	$('footer nav a').on('click', function () {
		const linkText = $(this).text().trim();

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'click',
			'click_action': 'Footer Menu click',
			'click_value': linkText
		});
	});


	// Handle mega menu link clicks - make entire div clickable while preserving anchor functionality
	$(document).on('click', '.wp-block-group.mega-menu-link', function (e) {
		// If clicking directly on the anchor, let it work normally
		if ($(e.target).is('a') || $(e.target).closest('a').length) {
			return; // Let the anchor handle the click naturally
		}

		// If clicking elsewhere in the div, simulate the anchor click
		const $anchor = $(this).find('a').first();
		if (!$anchor.length) {
			return;
		}

		const href = $anchor.attr('href');
		const target = ($anchor.attr('target') || '').toLowerCase();

		if (target === '_blank') {
			window.open(href, '_blank', 'noopener');
		} else {
			window.location.href = href;
		}
	});

})(jQuery);